'use strict';

angular.module('study.ecrd.field.queries')
    .controller('FieldReplyQueryController', ['$scope', 'query', 'CrdConfigurationService', function($scope, query, CrdConfigurationService) {
        var vm = this;

        // Por seguridad, si la nota está cerrada, no se puede responder
        if (query.lastText.status === 'closed') {
            $scope.dismissThisDialog('entity-note-reply-closed'); // eslint-disable-line angular/controller-as
        }

        // Model
        vm.reply = {
            status: query.lastText.status === 'new' ? 'updated' : query.lastText.status,
            text: '',
        };

        vm.messages = CrdConfigurationService.getQueries().getFixedMessages().reply;
        vm.hasPresetMessages = vm.messages && vm.messages.length > 0;

        vm.allowManualInput = false;
        vm.requireManualInput = false;

        vm.fixedMessage = null;

        // Control de error para incluir el mensaje teniendo en cuenta las opciones predefinidas si hay
        vm.error = {};

        // Actions
        vm.replyQuery = function() {
            if (vm.fixedMessage) {
                if (vm.reply.text) {
                    vm.reply.text = [vm.fixedMessage.message, vm.reply.text].join('\n');
                } else {
                    vm.reply.text = vm.fixedMessage.message;
                }
            }

            $scope.closeThisDialog(vm.reply);  // eslint-disable-line angular/controller-as
        };

        vm.closeModal = function() {
            $scope.dismissThisDialog('entity-note-reply-cancelled'); // eslint-disable-line angular/controller-as
        };

        vm.setFixedMessage = function() {
            if (vm.fixedMessage) {
                vm.allowManualInput = vm.fixedMessage.manual !== 'forbid';
                vm.requireManualInput = vm.fixedMessage.manual === 'require';
            } else {
                // Si hay mensajes prefijados significa que no se ha elegido ninguno, primero hay que elegir uno válido
                // Si no hay mensajes predefinidos, entonces la introducción manual es siempre obligatoria
                vm.allowManualInput = !vm.hasPresetMessages;
                vm.requireManualInput = !vm.hasPresetMessages;
            }

            if (!vm.allowManualInput && vm.manualReason) {
                // Actualizar mensaje manual vacío si no se requiere
                vm.reply.text = '';
            }
        };

        // Inicialización de las variables de control
        vm.setFixedMessage();
    }]);
